var random = require('./random');

    /**
     * returns a random boolean value (true or false)
     */
    function randBool(){
        return random() >= 0.5;
    }

    module.exports = randBool;





//////////////////
// WEBPACK FOOTER
// ./~/mout/random/randBool.js
// module id = 398
// module chunks = 0 1 2